<template>
    <div class="main bbt-main">
        <div class="author-banner" style="height:58px;">
            <div class="author-banner__bg" :style="{backgroundImage:`url(${publicPath}default/author@2x.png)`, height:`160px`}"></div>
        </div>
        <div class="bbt-container">
            <div class="author-module">
                <div class="author-overview bbt-clearfix">
                    <div class="author-overview__avatar">
                        <div class="img-box" :style="{backgroundImage: `url(${publicPath}default/avatar.webp)`}"  v-if="authorDetail.author.authorImage == null">
                        </div>
                        <div class="img-box" :style="{backgroundImage: `url(${authorDetail.author.authorImage})`}"  v-else>
                        </div>
                    </div>
                    <div class="author-overview__info">
                        <div class="author-overview__info-name">
                            <strong>{{authorDetail.author.userName}}</strong>
                            <span class="author-overview__info-item">浏览量 <span>{{authorDetail.author.viewCount}}</span></span>
                            <span class="author-overview__info-item">获赞数 <span>{{authorDetail.author.supportCount}}</span></span>
                            <span class="author-overview__info-item">粉丝数 <span>{{authorDetail.author.fansCount}}</span></span>
                        </div>
                        <div class="author-overview__info-desc">{{authorDetail.author.descriptions}}</div>
                        <div class="author-overview__posts bbt-clearfix">
                            <!-- <div data-v-23514466="" data-initialized="true" class="social-share share-component">
                                <a href="http://service.weibo.com/share/share.php?url=https%3A%2F%2Fwww.8btc.com%2Fauthor%2F46580&amp;title=%E6%B5%B7%E4%BC%A6%EF%BC%8C%E5%B7%B4%E6%AF%94%E7%89%B9%E5%8C%97%E4%BA%AC%E7%AB%99%E8%AE%B0%E8%80%85&amp;pic=&amp;appkey=" class="social-share-icon icon-weibo" target="_blank">
                                <i class="bbt-icon bbt-icon-weibo" style="color: rgb(238, 0, 0); margin-right: 18px; font-size: 24px;"></i>
                                </a>
                                <a href="javascript:" class="social-share-icon icon-wechat">
                                    <i class="bbt-icon bbt-icon-wechat" style="color: rgb(130, 160, 28); margin-right: 18px; font-size: 24px;"></i>
                                    <div class="wechat-qrcode"><h4>null</h4>
                                        <div class="qrcode" title="https://www.8btc.com/author/46580">
                                        <canvas width="100" height="100" style="display: none;"></canvas>
                                        <img alt="Scan me!" style="display: block;" src="data:image/png;base64,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">
                                        </div>
                                        <div class="help">
                                            <i class="bbt-icon bbt-icon-wechat" style="color: rgb(130, 160, 28); font-size: 20px;"></i>微信扫一扫
                                        </div>
                                    </div>
                                </a>
                            </div> -->
                            <button v-if="concernFlag == 1" @click="concernSave" class="author-overview__follow bbt-btn bbt-btn--primary">
                                <i class="el-icon-plus"></i> 关注
                            </button>
                            <el-button v-else @click="concernSave" type="info" class="author-module__follow" plain>取消关注</el-button>
                        </div>
                    </div>
                </div>
                <div class="bbt-row" style="margin-left:-12px;margin-right:-12px;">
                    <div class="bbt-col-xs-17" style="padding-left:12px;padding-right:12px;">
                        <div class="bbt-tab bbt-tab--lg">
                            <ul class="bbt-tab__menu bbt-clearfix">
                                <li class="active">文章<span>{{authorDetail.author.articleCount}}</span></li>
                                <!-- <li class="">收到的评论<span>133</span></li> -->
                            </ul>
                            <div class="li-active__line" style="left: 0px; width: 78px; opacity: 1;"></div>
                        </div>
                        <div class="bbt-subtab bbt-clearfix" style="margin:24px 0;">
                            <ul class="bbt-subtab__menu bbt-clearfix down">
                                <li class="active">
                                最新
                                </li>
                            </ul>
                        </div>
                        <div>
                            <div style="margin-bottom:24px;margin-top:-8px;">
                                <div v-if="authorArticles.length > 0">
                                    <div class="article-item-warp" v-for="item in authorArticles" :key="item.id">
                                        <div class="article-item bbt-clearfix">
                                            <div class="article-item__thumb">
                                                <a href="javascript:;" class="">
                                                <img :src="item.imagUrl" lazy="loaded">
                                                </a>
                                                <!-- <span class="bbt-label bbt-label--top bbt-label--rose">
                                                海盗号
                                                </span> -->
                                            </div>
                                            <div class="article-item__body">
                                                <h3 class="article-item__title">
                                                    <router-link :to="{path:'/articleDetail/' + item.id}" class="link-dark-major font-bold bbt-block">
                                                        {{item.title}}
                                                    </router-link>
                                                </h3>
                                                <div class="article-item__content" v-html="item.content"></div>
                                                <div class="article-item__info bbt-clearfix">
                                                    <div class="article-item__author">
                                                        <router-link :to="{path:'/authorDetail/' + item.authorId}" class="link-dark-major article-item__author-name">
                                                        {{item.author}}
                                                        </router-link>
                                                        {{ $filters.formatDate(item.createTime) }}
                                                        <!-- <span class="bbt-dot"></span> -->
                                                        <span v-if="item.tags.length > 0">
                                                            <a href="javascript:;" 
                                                                class="bbt-tag bbt-tag--flame  bbt-tag--sm" v-for="tag in item.tags.split(',')" v-bind:key="tag">
                                                                {{tag}}
                                                            </a>
                                                        </span>
                                                    </div>
                                                    <div class="article-item__data">
                                                        <span><i class="el-icon-view"></i> {{item.viewCount}}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                <div v-else>
                                    <div class="article-item-warp" v-for="item in myPostList" :key="item.id">
                                        <div class="article-item bbt-clearfix">
                                            <!-- <div class="article-item__thumb">
                                                <a href="javascript:;" target="_blank" class="">
                                                <img :src="item.imagUrl" lazy="loaded">
                                                </a>
                                                <span class="bbt-label bbt-label--top bbt-label--rose">
                                                海盗号
                                                </span>
                                            </div> -->
                                            <div class="article-item__body">
                                                <h3 class="article-item__title">
                                                    <router-link :to="{path:'/articleDetail/' + item.id}" class="link-dark-major font-bold bbt-block">
                                                        {{item.title}}
                                                    </router-link>
                                                </h3>
                                                <div class="article-item__content" v-html="item.content"></div>
                                                <div class="article-item__info bbt-clearfix">
                                                    <div class="article-item__author">
                                                        <!-- <router-link :to="{path:'/authorDetail/' + item.authorId}" target="_blank" class="link-dark-major article-item__author-name">
                                                        {{item.author}}
                                                        </router-link> -->
                                                        <!-- {{item.createTime | timeInteval}} -->
                                                        <!-- <span class="bbt-dot"></span> -->
                                                        <!-- <span v-if="item.tags.length > 0">
                                                            <a href="javascript:;" 
                                                                class="bbt-tag bbt-tag--flame  bbt-tag--sm" v-for="tag in item.tags.split(',')" v-bind:key="tag">
                                                                {{tag}}
                                                            </a>
                                                        </span> -->
                                                    </div>
                                                    <!-- <div class="article-item__data">
                                                        <span><i class="el-icon-view"></i> {{item.viewCount}}</span>
                                                    </div> -->
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="bbt-row" style="margin-left:-12px;margin-right:-12px;">
                                <div class="bbt-col-xs-24" style="padding-left:12px;padding-right:12px;">
                                    <div class="bbt-btn bbt-btn--default bbt-btn--lg bbt-btn-block" @click="loadMoreArticle" v-if="hasMoreArticle">
                                        查看更多
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="bbt-col-xs-7" style="padding-left:12px;padding-right:12px;">
                        <div class="bbt-module">
                            <div class="bbt-module__header">
                                热门资讯
                                <!-- <span class="orderby-nav">
                                    <span class="orderby-nav__text active">日排行</span>
                                    <span class="middot">·</span>
                                    <span class="orderby-nav__text">周排行</span>
                                </span> -->
                            </div>
                            <div class="article-box">
                                <div v-for="(item, index) in reArticles" :key="item.id">
                                    <div :class="{'article-item':true, 'article-item--lg':true}" v-if="index == 0">
                                        <!-- <span class="bbt-label bbt-label--top bbt-label--dark">
                                            <span>热议中</span>
                                        </span> -->
                                        <div class="article-item__thumb" >
                                            <router-link :to="{path:'/articleDetail/' + item.id}">
                                                <div :style="{backgroundImage: `url(${item.imagUrl})`}"></div>
                                            </router-link>
                                        </div>
                                        <div class="article-item__body">
                                            <div class="article-item__title">
                                                <router-link :to="{path:'/articleDetail/' + item.id}" class="bbt-block link-light-major">
                                                    {{item.title}}
                                                </router-link>
                                            </div>
                                        </div>
                                    </div>
                                    <div :class="{'article-item':true, 'article-item--small':true}" v-else>
                                        <!-- <span class="bbt-label bbt-label--top bbt-label--dark">2</span> -->
                                        <div class="article-item__thumb">
                                            <router-link :to="{path:'/articleDetail/' + item.id}">
                                                <div :style="{backgroundImage: `url(${item.imagUrl})`}"></div>
                                            </router-link>
                                        </div>
                                        <div class="article-item__body">
                                            <div class="article-item__title">
                                                <router-link :to="{path:'/articleDetail/' + item.id}" class="bbt-block link-dark-major">
                                                    {{item.title}}
                                                </router-link>
                                            </div>
                                            <div class="article-item__info bbt-clearfix">
                                                <span class="article-item__info-item"></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="bbt-module market-module">
                            <div class="bbt-module__header">
                                热门标签
                            </div>
                            <div class="bbt-module__body">
                                <router-link :to="{path:'/search/' + item}" class="bbt-tag bbt-tag--flame" v-for="item in hotTags" v-bind:key="item">
                                    {{item}}
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:'UserDetail',
    props:{
        serveHost: String
    },
    data:function() {
        return {
            publicPath: process.env.BASE_URL,
            hotTags:[],
            reArticles:[],
            authorArticles:[],
            myPostList:[],
            authorDetail:{},
            user:{},
            hasMoreArticle:true,
            pagNo:1,
            concernFlag: 1,
            APIS:[
                {
                    // 热门标签
                    name:'hotTags',
                    url:'/api/v1/article/getHatTags'
                },
                {
                    // 作者详情  /api/v1/article/author/作者ID/文章分页第一页
                    name:'authorDetail',
                    url:'/api/v1/article/author'
                },
                {
                    // 热门资讯
                    name:'reArticles',
                    url:'/api/v1/article/recommonderArticles'
                },
                {
                    // 我的帖子列表
                    name:'myPostList',
                    url:'/api/v1/user/mainpost'
                }
            ],
        }
    },
    methods:{
        loadMoreArticle:function() {
            // 文章列表更多加载
            this.pagNo++
            this.loadArticleList(this, this.pagNo);
        },
        loadDataByAsync:function(URL, DATA, CALLBACK_FUNC) {
            $.get(URL, DATA, CALLBACK_FUNC);
        },
        loadArticleList:function(_vm, pagNo) {
            var aysnUrl = ''
            if(this.$route.query.p === 'post') {
                aysnUrl = "/api/v1/user/mainpost/" + _vm.authorDetail.author.authorId + "/" + _vm.pagNo;
            } else {
                aysnUrl = "/api/v1/article/author/" + _vm.authorDetail.author.authorId + "/" + _vm.pagNo;
            }
            // 新闻列表
            this.loadDataByAsync(_vm.serveHost + aysnUrl, function(r){
                if(r.code != "2000000") {
                    console.error('get author articles error.');
                    _vm.hasnotArticle(_vm);
                    return;
                }
                if(r.data.articles) {
                    r.data.articles.forEach((item, index) => {
                        _vm.authorArticles.push(item);
                    });
                    _vm.articleLoad = false;
                    _vm.hasMoreArticle = true;
                } else {
                    _vm.hasnotArticle(_vm);
                }
            });
        },
        hasnotArticle(_vm) {
            _vm.hasMoreArticle = false;
            _vm.$alert('没有更多新闻了', '提示', {
                type:'warning',
                closeOnClickModal:true,
                closeOnPressEscape:true,
                confirmButtonText: '确定',
                callback: action => {
                    
                }
            });
        },
        concernSave:function() {
            var _vm = this;
            // 关注
            $.ajax({
                type:'POST',
                url:_vm.serveHost + "/api/v1/user/concern/save",
                data:{
                    userId: _vm.user.userid,
                    authorId: _vm.authorDetail.author.authorId,
                    concern: _vm.concernFlag
                },
                headers:{
                    Authorization:localStorage.getItem('token')
                },
                success:function(r) {
                    // console.log(r);
                    if(r.code != "2000000") {
                        _vm.$alert('关注失败，请先登录', '提示', {
                            type:'warning',
                            closeOnClickModal:true,
                            closeOnPressEscape:true,
                            confirmButtonText: '确定',
                            callback: action => {
                                
                            }
                        });
                        console.error('get concern save error.');
                        return;
                    } else {
                        if(_vm.concernFlag == 1) {
                            _vm.$message({
                                message:'关注成功',
                                type:'success'
                            });
                            _vm.concernFlag = 0;
                        } else {
                            _vm.$message('已取关');
                            _vm.concernFlag = 1;
                        }
                    }
                }
            });
        }
    },
    created () {
        var _vm = this;
        // console.log(this.$route.query);
        var p = this.$route.query.p;
        this.APIS.forEach((item, index) => {
            // 我的文章列表
            // if(item.name === 'authorDetail') {
            //     item.url = item.url + '/' + _vm.$route.params.user_id + '/1';
            // }
            // 我的帖子列表
            if((p === 'post' && item.name === 'myPostList') || item.name === 'authorDetail') {
                item.url = item.url + '/' + _vm.$route.params.user_id + '/1';
            } 
            _vm.loadDataByAsync(_vm.serveHost + item.url, function(r){
                if(r.code != "2000000") {
                    console.error('get '+ item.name +' error.');
                    // return;
                } else {
                    _vm[item.name] = r.data;
                    if(item.name === 'authorDetail' && p != 'post') {
                        _vm.authorArticles = r.data.articles;
                    }
                }
                _vm.authorDetailLoading = false;
            });
        });
        this.user = localStorage.getItem('user') == null? {} : JSON.parse(localStorage.getItem('user'));
    }
}
</script>


<style scoped>
.link-dark-major:hover {
    color: #e00;
}
.font-bold {
    font-weight:700;
}

.bbt-main {
    padding-bottom: 48px;
}

.bbt-row:after {
    clear: both;
}

.bbt-row:after, .bbt-row:before {
    content: " ";
    display: table;
}
.author-banner {
    width: 100%;
    height: 160px;
    text-align: center;
    background: #1e1e1e;
}
.author-banner__bg {
    padding: 18px 0;
    background-repeat: no-repeat;
    background-position: 50%;
    background-size: cover;
    color: #fff;
}
.bbt-col-xs-17 {
    float: left;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 70.83333333%;
}
.bbt-col-xs-7 {
    float: left;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 29.16666667%;
}
@media (min-width: 1200px) {
    .bbt-container {
        width: 1200px;
    }
}
.bbt-container {
    padding-left: 12px;
    padding-right: 12px;
    margin: 0 auto;
}
.author-overview {
    padding: 32px;
    box-shadow: 0 6px 24px 2px rgba(0,0,0,.06), 0 6px 30px 5px rgba(0,0,0,.04), 0 0 10px -5px rgba(0,0,0,.08);
    background: #fff;
    border-radius: 8px;
    margin-bottom: 48px;
}
.author-overview__avatar {
    float: left;
    margin: 0 34px;
    border-radius: 50%;
    box-shadow: 0 4px 5px 0 rgba(0,0,0,.06), 0 1px 10px 0 rgba(0,0,0,.04), 0 0 4px -1px rgba(0,0,0,.08);
    background: #fff;
    padding: 4px;
    position: relative;
}
.author-overview__avatar .img-box {
    width: 136px;
    height: 136px;
    background-repeat: no-repeat;
    background-position: 50%;
    background-size: cover;
    border-radius: 50%;
    overflow: hidden;
}
.author-overview__info {
    padding-left: 234px;
    position: relative;
}
.author-overview__info-name {
    font-size: 30px;
    line-height: 38px;
    color: rgba(0,0,0,.88);
}
.author-overview__info-item {
    display: inline-block;
    color: rgba(0,0,0,.56);
    font-size: 14px;
    line-height: 22px;
    margin: 0 24px;
}
.author-overview__info-item>span {
    display: block;
    font-size: 20px;
    line-height: 28px;
    color: rgba(0,0,0,.88);
    font-weight: 700;
}
.author-overview__info-desc{
    font-size: 14px;
    line-height: 22px;
    color: rgba(0,0,0,.56);
    margin-top: 24px;
    height: 63px;
    word-break: break-all;
    display: -webkit-box;
    box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
}
.author-overview__posts {
    color: rgba(0,0,0,.56);
    font-size: 14px;
    line-height: 22px;
    padding: 7px 0;
    position: absolute;
    right: 0;
    top: 0;
}
.social-share, .social-share .social-share-icon {
    display: inline-block;
    vertical-align: middle;
}
.bbt-icon {
    line-height: 1;
    font-size: 14px;
}
.bbt-icon {
    font-family: bbt-icon!important;
    font-size: 16px;
    font-style: normal;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}


.author-overview__follow, .author-overview__unfollow {
    width: 122px;
    border-radius: 21px;
    font-size: 14px;
    line-height: 22px;
    font-weight: 700;
    margin-left: 16px;
}

.social-share .wechat-qrcode {
    display: none;
    border: 1px solid #eee;
    position: absolute;
    z-index: 9;
    bottom: -147px;
    left: -50px;
    width: 120px;
    padding: 10px 10px 5px;
    color: #666;
    font-size: 12px;
    text-align: center;
    background-color: #fff;
    box-shadow: 0 4px 5px 0 rgba(0,0,0,.06), 0 1px 10px 0 rgba(0,0,0,.04), 0 0 4px -1px rgba(0,0,0,.08);
    border-radius: 4px;
    transition: all .2s;
    -webkit-tansition: all .35s;
    -moz-transition: all .35s;
}
.bbt-icon-weibo:before {
    content: "\E615";
}
.bbt-tab__menu {
    position: relative;
}
ul {
    padding: 0;
    margin: 0;
}
.bbt-tab.bbt-tab--lg .li-active__line {
    bottom: -6px;
}
.bbt-tab .li-active__line {
    height: 4px;
    position: absolute;
    left: 0;
    width: 40px;
    bottom: 2px;
    border-radius: 2px;
    background: #e00;
    transition: all .3s ease;
}
.bbt-tab.bbt-tab--lg .bbt-tab__menu>li {
    font-size: 20px;
    line-height: 28px;
    padding: 0;
    position: relative;
}
.bbt-tab__menu>li.active {
    color: rgba(0,0,0,.88);
}
.bbt-tab__menu>li {
    font-size: 16px;
    line-height: 24px;
    color: rgba(0,0,0,.56);
    padding: 7px 0;
    float: left;
    list-style: none;
    position: relative;
    font-weight: 700;
    transition: all .3s ease;
}
.bbt-tab__menu>li+li {
    margin-left: 34px;
}
.bbt-tab__menu>li.active span {
    color: rgba(0,0,0,.56);
}
.bbt-tab__menu>li span {
    color: rgba(0,0,0,.56);
    font-size: 16px;
    line-height: 24px;
    margin-left: 8px;
}

.bbt-subtab__menu.down {
    height: 36px;
    transition: all .3s ease;
}
.bbt-subtab__menu {
    padding-left: 84px;
    padding: 0;
    list-style-type: none;
    overflow: hidden;
}
.bbt-subtab__menu li.active {
    background: #f46300;
    border-color: #f46300;
    color: #fff;
}
.bbt-subtab__menu li {
    display: inline-block;
    font-size: 12px;
    line-height: 20px;
    color: rgba(0,0,0,.56);
    text-align: center;
    padding: 3px 12px;
    border: 1px solid rgba(0,0,0,.1);
    border-radius: 14px;
    margin-right: 14px;
    margin-bottom: 12px;
    cursor: pointer;
    transition: all .3s ease;
}
.bbt-tab {
    position: relative;
    margin-bottom: 24px;
}

.bbt-label.bbt-label--top {
    position: absolute;
    top: 8px;
    left: 0;
    z-index: 2;
}
.bbt-label {
    padding: 4px 16px 4px 8px;
    font-size: 12px;
    line-height: 20px;
    color: #fff;
    border-top-right-radius: 28px;
    border-bottom-right-radius: 28px;
}

.bbt-avatar.bbt-avatar--xs {
    max-width: 24px!important;
    width: 24px!important;
    height: 24px!important;
}
.bbt-avatar {
    border-radius: 50%;
    vertical-align: middle;
}

.link-dark-major {
    color: rgba(0,0,0,.88);
    transition: all .3s ease;
}

.bbt-dot {
    width: 4px;
    height: 4px;
    display: inline-block;
    background: rgba(0,0,0,.08);
    border-radius: 50%;
    margin: 0 8px 0 4px;
    vertical-align: middle;
}

.bbt-module {
    margin-bottom: 48px;
    background: #f8f8f8;
    padding: 24px;
    border-radius: 4px;
    transition: all .3s ease;
}

.bbt-module__header {
    font-size: 20px;
    line-height: 28px;
    color: rgba(0,0,0,.88);
    font-weight: 700;
    margin-bottom: 16px;
    position: relative;
    padding-left: 12px;
}

.orderby-nav {
    padding: 4px 0;
    float: right;
    font-size: 14px;
    line-height: 22px;
    color: rgba(0,0,0,.56);
    font-weight: 400;
}

.orderby-nav__text.active, .orderby-nav__text:hover {
    color: rgba(0,0,0,.88);
}
.orderby-nav__text {
    cursor: pointer;
    transition: all .3s ease;
}

.orderby-nav .middot {
    margin: 0 6px;
}

.orderby-nav__text {
    cursor: pointer;
    transition: all .3s ease;
}

.bbt-label.bbt-label--dark {
    background: rgba(0,0,0,.56);
}

.bbt-label.bbt-label--top {
    position: absolute;
    top: 8px;
    left: 0;
    z-index: 2;
}
.bbt-label {
    padding: 4px 16px 4px 8px;
    font-size: 12px;
    line-height: 20px;
    color: #fff;
    border-top-right-radius: 28px;
    border-bottom-right-radius: 28px;
}

.link-light-major {
    color: #fff;
    transition: all .3s ease;
}
.bbt-block {
    display: block;
}

.bbt-module__header {
    font-size: 20px;
    line-height: 28px;
    color: rgba(0,0,0,.88);
    font-weight: 700;
    margin-bottom: 16px;
    position: relative;
    padding-left: 12px;
}

.market-module__tab {
    position: relative;
}

.market-module__tab ul {
    padding-left: 0;
    margin-top: 0;
    margin-bottom: 16px;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: justify;
    justify-content: space-between;
    position: relative;
}

.market-module__tab ul li.active {
    color: rgba(0,0,0,.88);
    border-color: #e00;
}

.market-module__tab ul li {
    list-style: none;
    display: inline-block;
    font-size: 16px;
    line-height: 24px;
    font-weight: 700;
    color: rgba(0,0,0,.56);
    cursor: pointer;
    position: relative;
}

.market-module__tab .li-active__line {
    position: absolute;
    bottom: -2px;
    left: 0;
    width: 32px;
    background: #e00;
    height: 2px;
    border-radius: 1px;
    transition: all .3s ease;
}
/* .article-item__thumb>a {
    display: block;
    width: 100%;
    height: 100%;
}

.article-item--lg .article-item__thumb {
    width: 100%;
    height: 166px;
    display: block;
}

.article-item--lg .article-item__title {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 8px 16px;
    margin: 8px;
    background: rgba(0,0,0,.56);
    font-size: 14px;
    line-height: 22px;
    font-weight: 700;
    border-radius: 4px;
    z-index: 2;
    transition: all .3s ease;
}

.article-item {
    position: relative;
    margin-bottom: 24px;
} */

.bbt-module__header:before {
    content: "";
    width: 4px;
    height: 20px;
    position: absolute;
    top: 4px;
    left: 0;
    border-radius: 2px;
    background: #e00;
}

.market-module__list {
    padding-left: 0;
    margin: 0;
}
.market-module__list li {
    list-style: none;
}
.market-module__item {
    font-size: 14px;
    line-height: 22px;
    font-weight: 700;
    color: rgba(0,0,0,.88);
    height: 59px;
    padding: 8px 0;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: justify;
    justify-content: space-between;
    position: relative;
}
.market-module .item__name {
    font-weight: 700;
    position: relative;
    width: 80px;
    z-index: 1;
}
.market-module .item__price {
    position: relative;
    z-index: 1;
    font-weight: 700;
    width: 80px;
    text-align: right;
}
.market-module .item__scale {
    position: relative;
    z-index: 1;
    text-align: right;
}
.market-module .item__transition {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 0;
    opacity: 0;
}

.market-module .item__name span {
    font-size: 12px;
    line-height: 20px;
    color: rgba(0,0,0,.56);
}

.market-module .item__price--usd {
    font-size: 12px;
    color: rgba(0,0,0,.56);
    display: inline-block;
}
.market-module .item__scale--up span {
    background: #14954b;
    color: #fff;
    padding: 3px 4px;
    border-radius: 3px;
    margin-top: 10px;
    display: inline-block;
}
.market-module .item__scale span {
    font-size: 12px;
    line-height: 1;
}
.market-module__list li+li {
    border-top: 1px dashed rgba(0,0,0,.08);
}

</style>